import { Box, Card, Grid, Typography } from "@mui/material";
import { Insights } from "@mui/icons-material";
import RadialGauge from "../RadialGauge";
import "../../progressSection.css";

const GAUGE_COLORS = ["#4f46e5", "#fb8b24", "#14b8a6", "#f5b700"];

const KpiPerformanceCard = ({ rows }) => (
  <Card className="progressCard" elevation={0}>
    <Box className="progressHeaderLeft">
      <Insights className="progressHeaderIcon" />
      <Typography component="strong" className="progressHeaderTitle">
        KPI PERFORMANCE
      </Typography>
    </Box>
    <Grid container spacing={2} sx={{ marginTop: "4px" }}>
      {rows.map((row, index) => (
        <Grid item xs={6} key={row.label} sx={{ display: "flex", justifyContent: "center" }}>
          <RadialGauge value={row.value} label={row.label} color={GAUGE_COLORS[index % GAUGE_COLORS.length]} />
        </Grid>
      ))}
    </Grid>
  </Card>
);

export default KpiPerformanceCard;
